import { HardwareModels } from "types/productTypes";

const PICO_LAUNCHER_CONFIG_MODELS: readonly HardwareModels[] = [
  HardwareModels.PicoNeo3ProEye,
  HardwareModels.Pico4Enterprise,
];

const PICO_SEETHROUGH_CONFIG_MODELS: readonly HardwareModels[] = [
  ...PICO_LAUNCHER_CONFIG_MODELS,
  HardwareModels.PicoSwan,
];

export const pushesPicoLauncherConfig = (model: HardwareModels): boolean =>
  PICO_LAUNCHER_CONFIG_MODELS.includes(model);

const GRANTS_PERMISSIONS_ON_INSTALL_MODELS: readonly HardwareModels[] = [
  HardwareModels.Dpvr,
  HardwareModels.PicoSwan,
  HardwareModels.HtcFocusVision,
];

export const pushesPicoSeethroughConfig = (model: HardwareModels): boolean =>
  PICO_SEETHROUGH_CONFIG_MODELS.includes(model);

export const grantsPermissionsOnInstall = (model: HardwareModels): boolean =>
  GRANTS_PERMISSIONS_ON_INSTALL_MODELS.includes(model);

const STORAGE_PERMISSIONS = [
  "android.permission.READ_EXTERNAL_STORAGE",
  "android.permission.WRITE_EXTERNAL_STORAGE",
];

export function getGrantedAppPermissions(model: HardwareModels): string[] {
  switch (model) {
    case HardwareModels.Dpvr:
      return STORAGE_PERMISSIONS;
    case HardwareModels.HtcFocusVision:
      return ["android.permission.ACCESS_FINE_LOCATION"];
    case HardwareModels.PicoSwan:
      return [
        ...STORAGE_PERMISSIONS,
        "com.picovr.permission.EYE_TRACKING",
        "com.picovr.permission.HAND_TRACKING",
      ];
    default:
      return [...STORAGE_PERMISSIONS, "com.picovr.permission.EYE_TRACKING"];
  }
}

export function getAllowedAppOps(model: HardwareModels, sdkInt: number): string[] {
  return [
    ...(sdkInt >= 30 ? ["MANAGE_EXTERNAL_STORAGE"] : []),
    "WRITE_SETTINGS",
    ...(model === HardwareModels.HtcFocusVision ? ["REQUEST_INSTALL_PACKAGES"] : []),
  ];
}

export const installsFromShellStaging = (model: HardwareModels): boolean =>
  model === HardwareModels.HtcFocusVision;

export const runsAsDeviceOwner = (model: HardwareModels): boolean =>
  model === HardwareModels.HtcFocusVision;
